// Contact — the front door for the support inbox.
//
// The ingest side has existed since PROP-159: mail to support@algonavis.com
// hits a Cloudflare Email Worker, which POSTs to the adminserver and opens a
// thread in the admin support queue. Nothing in the app ever named that
// address, so the pipeline had no way in — while copy elsewhere already told
// people to "ask support to restore it", pointing at a door that wasn't drawn.
//
// Deliberately a mailto rather than a form. A form needs an endpoint, spam
// handling and a delivery guarantee to reproduce what the mail path already
// does end to end; the address gives the sender a copy in their own Sent
// folder, which a form cannot.

import { useTranslation } from "react-i18next";
import { SUPPORT_EMAIL } from "@/constants/support";

export function Contact() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto w-full max-w-xl px-5 py-12">
      <h1 className="text-[22px] font-semibold tracking-[-0.01em] text-text">
        {t("contact.title")}
      </h1>
      <p className="mt-2 text-[14px] leading-relaxed text-text-sec">
        {t("contact.lede")}
      </p>

      <a
        href={`mailto:${SUPPORT_EMAIL}`}
        className="mt-6 inline-flex items-center gap-2 rounded-lg border border-border bg-surface-3 px-4 py-3 text-[14px] font-medium text-text transition hover:border-border-strong"
      >
        {SUPPORT_EMAIL}
      </a>

      <p className="mt-6 text-[12.5px] leading-relaxed text-text-muted">
        {t("contact.note")}
      </p>
    </div>
  );
}
